module.exports = __webpack_public_path__ + "static/media/carousel_1.ea6244e6.jpg";